<template>
  <div class="measurement-result-patient-detail">
    <div class="row upper">
      <div class="item show-id">
        <div class="label">患者ID：</div>
        <div class="value">{{ patientShowId }}</div>
      </div>
      <div class="item name">
        <div class="label">患者名：</div>
        <div class="value">{{ patientName }}</div>
      </div>
    </div>
    <div class="row middle">
      <div class="item birthday">
        <div class="label">生年月日：</div>
        <div class="value">{{ birthday }}</div>
      </div>
      <div class="item age">
        <div class="label">年齢（検査当時）：</div>
        <div class="value">{{ ageAtRunDate }}</div>
      </div>
    </div>
    <div class="row lower">
      <div class="item species-breed fit-content">
        <div class="label">種類：</div>
        <div class="value" :title="speciesBreed">
          <span>{{ speciesBreed }}</span>
        </div>
      </div>
      <div class="item lab-species">
        <div class="label">検査動物種：</div>
        <div class="value">{{ labSpeciesName }}</div>
      </div>
      <div class="item sex-name">
        <div class="label">性別：</div>
        <div class="value">{{ patientSex }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { calcAgeAtDate, calcMonthAgeAtDate } from '@/utils/patient_info'
import { mapGetters } from 'vuex'

export default {
  name: 'MeasurementResultPatientDetail',

  props: {
    patient: { type: Object },
    runDate: { type: String, default: '' }
  },

  computed: {
    ...mapGetters({
      getMaster: 'master/getData',
      getSpecies: 'species/getDataById'
    }),
    ageAtRunDate() {
      const runDate = this.runDate
      if (!runDate) return ''
      const patient = this.patient
      if (!patient) return ''
      if (!Object.hasOwn(patient, 'birthday')) return ''
      const birthday = patient.birthday || ''
      if (birthday === '') return '※生年月日未設定'
      if (runDate < birthday) return '※生年月日前'
      const deathDate = patient.deathDate || ''
      if (deathDate && deathDate < runDate) return '※死亡'
      const ageAtRunDate = calcAgeAtDate(patient, runDate)
      const monthAgeAtRunDate = calcMonthAgeAtDate(patient, runDate)
      return ageAtRunDate && monthAgeAtRunDate
        ? `${ageAtRunDate}（月齢 ${monthAgeAtRunDate}）`
        : ''
    },
    birthday() {
      const patient = this.patient
      const birthday = patient?.birthday ?? ''
      return birthday.length === 8
        ? moment(birthday, 'YYYYMMDD').format('YYYY.MM.DD')
        : birthday.length === 6
        ? moment(birthday, 'YYYYMM').format('YYYY.MM.--')
        : birthday.length === 4
        ? moment(birthday, 'YYYY').format('YYYY.--.--')
        : '----.--.--'
    },
    labSpeciesName() {
      const speciesCode = this.patientSpecies?.masterLaboratorySpeciesCode ?? ''
      const labSpeciesList = this.getMaster('masterLaboratorySpecies')
      const labSpecies = labSpeciesList.find(v => v.code === speciesCode)
      return labSpecies?.name ?? '未設定'
    },
    patientName() {
      return this.patient?.name ?? ''
    },
    patientSex() {
      const patientSexes = this.getMaster('patientSexes')
      const patientSexId = this.patient?.sex
      const patientSex = patientSexes.find(v => v.id === patientSexId)
      return patientSex?.name ?? '未設定'
    },
    patientShowId() {
      return this.patient?.showId ?? ''
    },
    patientSpecies() {
      const speciesId = this.patient?.speciesId
      return this.getSpecies(speciesId)
    },
    speciesBreed() {
      const speciesName = this.patientSpecies?.name ?? ''
      const breed = this.patient?.breed ?? ''
      return `${speciesName}/${breed}`
    }
  }
}
</script>

<style lang="scss" scoped>
.measurement-result-patient-detail {
  box-sizing: border-box;
  padding: 0 4px 4px 4px;
  > .row {
    display: flex;
    column-gap: 18px;
    height: 22px;
    > .item {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      font-size: 13px;
      &.fit-content {
        flex: 1;
        width: 0;
        max-width: fit-content;
      }
      > .label {
        font-weight: bold;
      }
      > .value {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
